import React from "react";

const bindComponent = (bindings, Component) => props => (
  <Component {...props} {...bindings} />
);

export default bindComponent;
